import React, { useEffect, useState } from "react";
import "./CSS1/team.css";
import flowerImg from "./images/lightPinkBrain.png";
import teamLinkedin from "./images/linkedInGeminiNew.png";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import cross1 from "./images/crossover.png";

const Team = ({ page, id }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    width: 636,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);

  const [idKnowMore, setIdKnowMore] = useState();
  const [idKnowMore1, setIdKnowMore1] = useState();

  const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);
  // // console.log(handleClose1, "clicked")

  const teamData = [
    {
      id: "1",
      name: "Akshay Gupta",
      deg: "CEO & Founder",
      about:
        "Akshay, an art lover & happiness maven, has over15 year of experience in building and managing products in the field of fintech, Blockchain startups, process improvement, human health and neuroscience.",
      linkedin: "https://www.linkedin.com/in/akshay-gupta-profile/",
      moreAbout:
        "Akshay, an art lover & happiness maven, has over15 year of experience in building and managing products in the field of fintech, Blockchain startups, process improvement, human health and neuroscience. <br/> <br/> He even mentored the growth of over 10 North American startups. He holds Master of Technology Entrepreneurship and Innovation (a graduate degree specialising in tech startups) degree from Saint Mary’s University in Canada, an undergraduate degree in Business Economics from the University of Delhi, and an Agile Meets Design Thinking Certification from the University of Virginia. <br/> <br/> In his professional journey, he witnessed and experienced how stress, anxiety and burnout brought turmoil to today’s youth. To contribute to his Bit, he was involved in non-profit mental health charitable groups for over 15 years. His passion for happiness and human health inspired him to start Bit Happier, where evidence-based neuroscience tools are provided to help individuals live happier lives.In 2016, his introduction to blockchain technology led to his deep dive into the field. <br/> <br/>  As a result, he won the prestigious Durland Innovation Award for a Blockchain application in 2017. He is passionate about the impact of new technologies on individual happiness and well-being. So now, Akshay and the Bit Happier team are focused on bringing the Bit Happier tools and resources to help individuals and communities live happier and healthier.",
      image: "/./images/akshay.png",
    },
    {
      id: "2",
      name: "Neil Haran",
      deg: "Chief Strategy Officer",
      about:
        "Early Zynga employee (Lead gameplay engineer). Senior systems engineer for LucasArts Central tech. Gameplay & Al engineer NHL, NBA, FIFA.",
      linkedin: " https://www.linkedin.com/in/neilharan/",
      moreAbout:
        "Early Zynga employee (Lead gameplay engineer) .Senior systems engineer for LucasArts Central tech. Gameplay & Al engineer NHL, NBA, FIFA.  Well-Versed in Blockchain technology and Gamification Methods.",
      image: "/./images/niel.png",
    },
    {
      id: "3",
      name: "Dr. Olga Yashchuk",
      deg: "Chief Mental Wellness Officer",
      about:
        "Dr. Olga Yashchuk is a psychiatrist based in Vancouver, Canada. She is an avid traveller, amateur chef and a beginner photographer.",
      linkedin: "https://www.linkedin.com/in/olga-yashchuk-md-frcpc-71228598/",
      moreAbout:
        "Dr. Olga Yashchuk is a psychiatrist based in Vancouver, Canada. She has studied abroad and worked in other provinces in Canada before returning to Vancouver in early 2021.  She is an avid traveller, amateur chef and a beginner photographer. As part of her professional journey, she works with individuals struggling with mental health issues and strives to improve their well-being. Olga’s particular areas of interest include sleep medicine, understanding what makes individuals resilient throughout their life span, supporting  individuals in building their own resilience strategies and helping individuals lead fulfilled and meaningful lives. The area of mental and wellbeing is continuously evolving and she is excited to be part of the Bit Happier community, which  focuses on providing evidence-based tools and strategies to help individuals address their mental health needs and support them in leading happier, healthier, and more meaningful lives.",
      image: "/./images/olga.png",
    },
    {
      id: "4",
      name: "Heather Van Tassel",
      deg: "Data and AI Scientist",
      about:
        "Master's in Data Science from UBC. She has worked for several tech start-ups in women's wellness, education, and collaborative decision-making.",
      linkedin: "https://www.linkedin.com/in/heather-van-tassel/",
      moreAbout:
        "Master's in Data Science from UBC. She has worked for several tech start-ups in women's wellness, education, and collaborative decision-making. Master's in Data Science from UBC. She has worked for several tech start-ups in women's wellness, education, and collaborative decision-making. Neuroscientist turned data scientist, she enjoys data analysis, data visualization, public speaking, and community-building",
      image: "/./images/heather.png",
    },
    {
      id: "5",
      name: "Arun Kumar",
      deg: "Chief Technology Lead",
      about:
        "Veteran Software Developer with 13+ Years of experience in IT and Project Management. B.Tech in Computer Science and Engineering Graduate.",
      linkedin: "https://www.linkedin.com/in/arun-passi-51aa7714/",
      moreAbout:
        " Veteran Software Developer with 13+ Years of experience in IT and Project Management. Bachelor of Technology in Computer Science and Engineering Graduate. Has worked for leading Japanese, American and Indian companies",
      image: "/./images/arun.png",
    },
    // {
    //   id: "6",
    //   name: "Ana Luisa ",
    //   deg: "Digital Marketing Specialist",
    //   about:
    //     "Ana, a student at a Vancouver university studying for a Bachelor of Arts in Business Communications, brings a diverse background to her studies.",
    //   linkedin: "https://www.linkedin.com/in/anafigsocialmedia/",
    //   moreAbout:
    //     "Ana, a student at a Vancouver university studying for a Bachelor of Arts in Business Communications, brings a diverse background to her studies. With an undergraduate degree in Social Communication from the Universidade de Brasillia (UnB) and experience in branding, graphic design, and content creation, Ana has a talent for analysing and interpreting data to evaluate the effectiveness of social media campaigns and has provided support to product design teams. In her leisure time, Ana indulges in her love of reading and writing by maintaining a blog that focuses on book reviews. She has previously worked with well-known brands in Brazil and has created content that has garnered significant attention, particularly her blog which has over 13,5K views.",
    //   image: "/./images/ana.png",
    // },
    {
      id: "7",
      name: "Tanya Bakshi",
      deg: "Mental Wellness Strategist",
      about:
        "Clinical Psychologist with an M.Phil degree in Clinical Psychology licensed by the Rehabilitation Council of India (RCI) and an M.A. in Clinical Psychology from Tata Institute of Social Sciences, Mumbai, India.",
      linkedin: "https://www.linkedin.com/in/tanyabakshi2011/",
      moreAbout:
        "Clinical Psychologist with an M.Phil degree in Clinical Psychology licensed by the Rehabilitation Council of India (RCI) and an M.A. in Clinical Psychology from Tata Institute of Social Sciences, Mumbai, India. Tanya is a qualified psychologist and has been working to provide evidence based and scientific treatment to individuals facing mental health concerns. She has worked as a full-time school counsellor and as a practicing psychologist for over four years in Chetana Counselling Centre, Perfect Mind Clinic, CIMBS Hospital, Army Research and Referral Hospital and National Institute of Empowerment of People with Intellectual Disabilities.  Her vision is one of providing quality psychological care, through the use of best practices and strategies for emotional, mental and behavioral improvement and holistic wellness.  Her experience, over the years, in hospitals, private clinics, rehabilitation centres and NGOs has helped to strengthen her diagnostic, psychological testing, psychotherapy and counselling skills. She has worked with clients dealing with anxiety, depression, anger along with relationship, family, work and career related concerns.",
      image: "/./images/tanya123.png",
    },
    {
      id: "8",
      name: "Aditya Gupta",
      deg: "Chief Management Officer",
      about:
        "Aditya is an entrepreneur & marketer with extensive experience in sales, marketing, business development, consulting and startups.",
      linkedin: "https://www.linkedin.com/in/aditya-gupta-0ab04348/",
      moreAbout:
        "Aditya is an entrepreneur & marketer with extensive experience in sales, marketing, business development, consulting and startups. His education includes MBA in Marketing & Strategy from IIM lucknow, India. He has initiated and groomed businesses in India, North and South America along with maximized business growth and revenue generation. A person of deep interactive skills and zeal, we are lucky to have him on our Bit Happier team.",
      image: "/./images/aditya.png",
    },
    {
      id: "9",
      name: "Ravi Gaikwad",
      deg: "Chief Scientific Officer",
      about:
        "Ravi is an accomplished physicist who brings extensive expertise to the fields of technology development, material science, nanotechnology, biophysics, health sciences, and eco-friendly remediation.",
      linkedin: "https://www.linkedin.com/in/rgaikwad/",
      moreAbout:
        "Ravi is an accomplished physicist who brings extensive expertise to the fields of technology development, material science, nanotechnology, biophysics, health sciences, and eco-friendly remediation. With a proven track record of managing projects and exceptional communication skills, he is a creative, out-of-the-box thinker. Ravi has held leadership positions including Director of a bio-remediation company, and has worked with top firms such as EY, MNP, and Ayming. He is also well-versed in SR&ED and clinical trials. ",
      image: "/./images/ravi.png",
    },
    {
      id: "10",
      name: "Navdip Sahota",
      deg: "Chief Clinical Officer",
      about:
        "Clinical pharmacist with diverse experience spanning retail pharmacy and specialized clinical practice particularly focused on diabetes and pump management within various endocrinologist office settings.",
      linkedin: "https://www.linkedin.com/in/navdip-sahota-bb797a99/",
      moreAbout:
        "Clinical pharmacist with diverse experience spanning retail pharmacy and specialized clinical practice particularly focused on diabetes and pump management within various endocrinologist office settings. Proven track record of delivering exceptional pharmaceutical care, optimizing medication therapy, empowering patients to achieve optimal glycemic control and improve overall health outcomes conditions through education on medication adherence, lifestyle modifications, and potential side effects. Adept at leveraging expertise in diabetes pharmacotherapy, continuous glucose monitoring (CGM) technology and patient education to provide comprehensive support to individuals with diabetes. Collaborative communicator skilled in interfacing with multidisciplinary healthcare teams to develop tailored treatment plans and enhance patient care delivery.",
      image: "/./images/navdip.png",
    },
    {
      id: "11",
      name: "Angela Dionisio",
      deg: "Research Analyst",
      about:
        "She graduated with a Bachelor of Arts in Psychology from SFU, where she gained experience in EEG analysis and psychology research labs throughout her studies. She is also passionate about mental health advocacy.",
      linkedin: "https://www.linkedin.com/in/angelaisabellee/",
      moreAbout:
        "She graduated with a Bachelor of Arts in Psychology from SFU, where she gained experience in EEG analysis and psychology research labs throughout her studies. She is also passionate about mental health advocacy.",
      image: "/./images/angela.JPG",
    },
    {
      id: "12",
      name: "Beata Jirava",
      deg: "Local Philanthropist and Innovator",
      about:
        "Beata is a strategic connector, visionary leader, and catalyst for innovation. She has partnered with startups, scientists, C-suite executives, and mission-driven organizations to bring transformative ideas to life.",
      linkedin: "https://www.linkedin.com/in/beata-jir/",
      moreAbout:
        "Beata is a strategic connector, visionary leader, and catalyst for innovation. She has partnered with startups, scientists, C-suite executives, and mission-driven organizations to bring transformative ideas to life.",
      image: "/./images/beata.png",
    },
    {
      id: "13",
      name: "Praveen Varshney",
      deg: "Partner | Varshney Capital Corp.",
      about:
        "Praveen has been a driving force in the Vancouver business world. He obtained a Bachelor of Commerce degree from the University of British Columbia in 1987.",
      linkedin: "https://www.linkedin.com/in/praveenvarshney/",
      moreAbout:
        "Praveen has been a driving force in the Vancouver business world. He obtained a Bachelor of Commerce degree from the University of British Columbia (UBC) in 1987. Following that, he was with KPMG from 1987 to 1991 where he obtained his C.A, designation in 1990, He is a director or officer of various publicly traded companies including Mogo (Co-Founder) and BetterU Education Corp. He is also a Co-Founder of G-PAK and former CFO of Carmanah Technologies Corp. which became Canada's largest solar company. First Angel Investor in Bit Happier Inc.",
      image: "/./images/praveen.png",
    },
    {
      id: "14",
      name: "Dave Richardson",
      deg: "Philanthropist and Mental Health Advocate",
      about: `Dave Richardson is the President and CEO of Octaform Systems Inc. and Co-Founder of the Stigma-Free Mental Health Society.`,
      linkedin: "https://www.linkedin.com/in/dave-richardson-34218513/",
      moreAbout: `Mr. Richardson is a Director of Richardson International Limited. He is a Director Emeritus of Ducks Unlimited Canada following 20 years on that board and remains dedicated to several other charities and philanthropic activities.

      He was a founding member and Director of The Asia Pacific Foundation and a leader on various government trade missions to Asia. In addition he was a Director of the Canada China Trade Council and Chairman of the Agriculture Committee.
      
      Mr. Richardson has served on a number of public and private boards throughout his career and continues to hold several other directorship positions.`,
      image: "/./images/david.png",
    },
    // {
    //   id: "12",
    //   name: "Monica",
    //   deg: "Social Media Strategist",
    //   about:
    //     "Monica graduated with a Bachelor of Commerce from University Canada West, where she developed strong skills in marketing, strategic management, and professional communication.",
    //   linkedin: "https://www.linkedin.com/in/monicalangenegger/",
    //   moreAbout:
    //     "Monica graduated with a Bachelor of Commerce from University Canada West, where she developed strong skills in marketing, strategic management, and professional communication. She gained hands-on experience through projects like the Capstone Project, where she led a business plan for a Vancouver-based company. Fluent in English, French, and Spanish, Monica brings a global perspective to her work. In her free time, she enjoys staying active at the gym, exploring new cultures, and immersing herself in books that inspire fresh ideas and perspectives.",
    //   image: "/./images/monica.jpeg",
    // },
  ];
  const advisorData = [

    {
      id: "2",
      name: "Andrea Paquette",
      deg: "Co-Founder & President | Stigma Free Society",
      about:
        "Andrea Paquette, AKA Bipolar Babe, created the Bipolar Babe project in 2009. She is now the President and Co-Founder of the Stigma-Free Society,",
      linkedin: "https://www.linkedin.com/in/andrea-paquette-45474a1a/",
      moreAbout:
        "Andrea Paquette, AKA Bipolar Babe, created the Bipolar Babe project in 2009. She is now the President and Co-Founder of the Stigma-Free Society, formerly the Bipolar Disorder Society of British Columbia, which she Founded in 2010 in collaboration with seven dedicated Board of Directors. Andrea currently oversees Charity operations and is the Co-Founder of the Stigma-Free Society in partnership with Co-Founder and Board Chair, Dave Richardson.",
      image: "/./images/andrea.png",
    },
    {
      id: "3",
      name: "Ashton Addison",
      deg: "CEO & Founder | Cryptocoin show",
      about:
        "Mr. Addison has been involved in the Blockchain industry since 2013. As the CEO and Founder of Event Chain, he pioneered EventChain’s unique solution.",
      linkedin: "https://www.linkedin.com/in/ashtonaddison/",
      moreAbout:
        "Mr. Addison has been involved in the blockchain industry since 2013. As the CEO and Founder of Event Chain, he pioneered Eventchain's unique solution to verifyin counterfeit event tickets using the blockchain, He also advises various other Blockchain companies globally including Syscoin and CoinPayments.net in Canada, Pundi X inIndonesia and Smart Mash in China. Together with Event Chain and his associated blockchain projects he has helped raise over $50M cumulatively.",
      image: "/./images/ashton.png",
    },
    {
      id: "4",
      name: "Karn Nichols",
      deg: "Executive Director | Canadian Mental Health Association, Nova Scotia",
      about:
        "Along with a deep compassion for those facing mental health and addiction issues, Karn Nichols brings over 25 years of leadership experience in both the ‘for profit’ and ‘for impact’ sectors...",
      linkedin: "https://www.linkedin.com/in/karnnichols/",
      moreAbout:
        "Along with a deep compassion for those facing mental health and addiction issues, Karn Nichols brings over 25 years of leadership experience in both the ‘for profit’ and ‘for impact’ sectors to the role of Executive Director of the Canadian Mental Health Association of Nova Scotia. A committed professional, who combines a broad range of leadership expertise and experience in human resources and operations disciplines, Karn has a collaborative leadership style and a proven ability to build solid relationships and gain buy-in within a diverse set of stakeholders. She enjoys opportunities to address new challenges requiring creativity, breaking existing paradigms and thinking strategically. Karn has always been deeply committed to both her family and community and has held several volunteer positions throughout the years. These would include Board Chair, MacPhee Centre for Creative Learning; Member of Board Executive for Junior Achievement Nova Scotia; Vice President External, Saint Mary’s University MBA Society; Co-President Families with Children from China; President Metro Immigrant Learning Society; Human Resources Association of Nova Scotia; Feed Nova Scotia; Blue Nose Marathon; Manulife Dragon Boat Festival and the Canadian Breast Cancer Foundation. Karn is the proud mother of Saya (New Zealand) and Ming (Halifax) and lives with her husband George in Hubley. When she is not working, she is running, hiking and travelling the world. She has an MBA from Saint Mary’s University, a BSc. in psychology from Dalhousie University, and a Certificate in Adult Education from Henson College.",
      image: "/./images/Karn.png",
    },
    {
      id: "5",
      name: "Justine Gauthier",
      deg: "Legal Strategy Advisor",
      about:
        "Justine Gauthier is a seasoned lawyer with expertise in artificial intelligence and technology matters. She is currently the Director of Corporate & Legal Affairs at a prominent artificial intelligence research institute.",
      linkedin:
        "https://www.linkedin.com/in/-justine-gauthier/?originalSubdomain=ca",
      moreAbout:
        "Justine Gauthier is a seasoned lawyer with expertise in artificial intelligence and technology matters. She is currently the Director of Corporate & Legal Affairs at a prominent artificial intelligence research institute, and has also been involved in non-for-profit organizations in the neuroscience, technology and art sectors. Justine previously practiced corporate and commercial law at a top Canadian law firm.",
      image: "/./images/justine.png",
    },
    // {
    //   id: "6",
    //   name: "Dave Richardson",
    //   deg: "Philanthropist and Mental Health Advocate",
    //   about: `Dave Richardson is the President and CEO of Octaform Systems Inc. and Co-Founder of the Stigma-Free Mental Health Society.`,
    //   linkedin: "https://www.linkedin.com/in/dave-richardson-34218513/",
    //   moreAbout: `Mr. Richardson is a Director of Richardson International Limited. He is a Director Emeritus of Ducks Unlimited Canada following 20 years on that board and remains dedicated to several other charities and philanthropic activities.

    //   He was a founding member and Director of The Asia Pacific Foundation and a leader on various government trade missions to Asia. In addition he was a Director of the Canada China Trade Council and Chairman of the Agriculture Committee.

    //   Mr. Richardson has served on a number of public and private boards throughout his career and continues to hold several other directorship positions.`,
    //   image: "/./images/david.png",
    // },
    // {
    //   id: "7",
    //   name: "Bhavik Chauhan",
    //   deg: "Managing Partner & Co-Founder | Bonsai Growth Solutions",
    //   about:
    //     "I Specialize in Business Development and Marketing, and have had a successful career to date in achieving objectives set out before me. ",
    //   linkedin:
    //     "https://www.linkedin.com/in/bhavik-chauhan-bngstrategybonsaigrowth/?originalSubdomain=ca",
    //   moreAbout:
    //     "I Specialize in Business Development and Marketing, and have had a successful career to date in achieving objectives set out before me. Networking and making contacts at decision making levels is a natural gift, and one of my most favored traits. Consistent top performer and great people management skills have made me a great leader, and allows me to keep core groups focused and targeted. I believe that everyday in the working world is an education; skills are developed from hour too hour if I take a few seconds to analyze what my peers have to say and I conduct it in my environment so I can reach new heights.",
    //   image: "/./images/bhavik.png",
    // },
    {
      id: "8",
      name: "Shivam Kishore",
      deg: "United Nations | Harvard University",
      about:
        "As a lifelong practitioner and teacher of yoga & mindfulness, the base for all my perspectives, relationships & decisions is formed through a deep understanding of self-awareness.",
      linkedin: "https://www.linkedin.com/in/shivamkishore/",
      moreAbout:
        "As a lifelong practitioner and teacher of yoga and mindfulness, the base for all my perspectives, relationships, and decisions is formed through a deep understanding of self-awareness. This base has been strengthened through professional and experiential learnings in more than sixty countries. I combine this fundamental yet globalized skillset with leadership and expertise in architecting, building, and launching large scale digital strategies, products and services. I excel at enabling systems-level transformations by intersecting strategy, innovation, and people. I thoroughly enjoy relationship management and multi-stakeholder analysis and engagement. ",
      image: "/./images/shivam.png",
    },
    // {
    //   id: "9",
    //   name: "Adnan Sarwar",
    //   deg: "Marketing Expert",
    //   about: `Adnan Sarwar, grew up in Bangladesh and worked with Dr. Muhammad Yunus, the 2006 Nobel Prize Winner and together they turned 10,000,000 "the poorest of the poor women" into Entrepreneurs.`,
    //   linkedin: "https://www.linkedin.com/in/thebusinessmonk?original_referer=",
    //   moreAbout: `He went to a London, U.K. and graduated at the top of his class at HULT University for both his BSc. and MBA plus worked for a non-profit CHEC raising money for funding human settlements globally and also as an Investment Banker for Merrill Lynch Bank in London, U.K. working with "the richest of the rich men" , then 9/11 happened and changed both his careers forever. 


    //     He immigrated to Canada and could not restart his career in banking, with no Canadian degree and no Canadian work experience and started a Real Estate Brokerage in Toronto, Canada until he lost everything in the 2008 - 2009 global real estate crash and financial crisis.


    //     He moved to Vancouver, Canada with a young family, started teaching at public and private colleges and universities as a Professor of Business and in his spare time, started a Financial Technology (FinTech) Practice with his best friends in Vancouver, Calgary, Toronto, Edmonton and Richmond, Canada over the last 10 years, helping 1,000+ clients for both personal and business financial planning.


    //     He has been teaching at local public and private colleges and now is a full time Professor at one of the largest private universities in Canada called University Canada West and also sits on the Advisory Board of the prestigious University of California, Riverside campus for their Design Thinking Program, with the senior executives of the Silicon Valley in the USA. 


    //     In his spare time, he mentors some of the up and coming Technology Start Up Entrepreneurs, serving as Vice President of one of the top Electric Vehicle (EV Bikes and Scooters) | Clean Tech | Green Tech Start Up called Nexpress and recently wrote a book for children on How Money Works and it is going to be published globally this year.
    //     `,
    //   image: "/./images/adnan.png",
    // },
    {
      id: "10",
      name: "Saarthak Bakshi",
      deg: "Healthcare Entrepreneur | Forbes 30U30",
      about:
        "Saarthak Bakshi, Chief Executive Officer (CEO) of the International Fertility Centre. He is known for his persona as an engineer, an entrepreneur and a social advocate.",
      linkedin: "https://www.linkedin.com/in/saarthakbakshi/",
      moreAbout:
        "Saarthak Bakshi, Chief Executive Officer (CEO) of the International Fertility Center. He is known for his persona as an engineer, an entrepreneur and a social advocate. He soon realized that he has an inborn passion for entrepreneurship and went on to launch a slew of ventures including International Fertility Center.  - FORBES 30 under 30 Asia - Entrepreneur 35 under 35 - Business Connect 40 under 40 - Medgate 40 under 40 - AsiaOne 40 under 40 - Multiple TedX Speaker",
      image: "/./images/saarthak.png",
    },
  ];
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <div
      className="container-fluid main-container-team"
      style={
        page === "landing"
          ? { background: "#ffe6eb" }
          : { background: "#ffe6eb" }
      }
      id={id || "team"}
    >
      {page === "landing" ? (
        <img src={flowerImg} className="flower-img" alt="" srcSet="" />
      ) : (
        ""
      )}
      <div
        className="container pb-5 team_main_container_div"
        style={{ position: "relative" }}
        id="OurTeam"
      >
        {page === "landing" ? (
          <div
            className="team-heading"
            style={{
              color: "white",
              padding: "4rem 0",
              fontWeight: "700",
              fontSize: "56px",
              zIndex: "10",
            }}
          >
            <span>The Team</span>
          </div>
        ) : (
          <div
            className="team-heading d-flex justify-content-center team--heading--about"
            id="ourteam"
            style={{
              color: "#201f24",
              padding: "0",
              fontWeight: "700",
              fontSize: "48px",
              zIndex: "10",
              textAlign: "center",

            }}
          >
            <span>Meet Our Founding Team Members</span>
          </div>
        )}
        <div className="row justify-content-center">
          {teamData.map((res) => {
            return (
              <>
                <div className="col-lg-3 col-md-4 px-2" key={res.id}>
                  <div className="team-card d-flex flex-column align-items-center justify-content-center">
                    <img
                      className="team-card-img"
                      src={res.image}
                      alt=""
                      srcSet=""
                    />
                    <div className="text-center team-text">
                      <span
                        className="titlespan"
                        style={{
                          fontSize: "25px",
                          color: "#4a3f42",
                          fontWeight: "700",
                          lineHeight: "1.1",
                        }}
                      >
                        {res.name}
                      </span>
                      <p
                        className="aboutpara"
                        style={{
                          fontSize: "16px",
                          color: "#6f6b6c",
                          fontWeight: "600",
                        }}
                      >
                        {res.deg}
                      </p>
                    </div>
                    <a
                      href={res.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <img src={teamLinkedin} width={25} alt="" srcSet="" />
                    </a>
                    <hr
                      style={{
                        color: "#A3A3A3",
                        width: "100%",
                        border: "1px solid #A3A3A3",
                      }}
                    />
                    <div
                      className="text-center about--para"
                      style={{ padding: "0 19px" }}
                    >
                      <p
                        className="about-team aboutpara"
                        style={{
                          fontSize: "11px",
                          color: "#6f6b6c",
                          fontWeight: "400",
                        }}
                      >
                        {res.about}
                      </p>
                    </div>
                    <span
                      role="button"
                      className="mb-4"
                      onClick={() => {
                        setIdKnowMore1(res.id);
                        // // console.log(id)
                        setOpen1(true);
                      }}
                      style={{ color: "#4a3f42", textDecoration: "underline" }}
                    >
                      Know More
                    </span>
                    {idKnowMore1 === res.id ? (
                      <Modal
                        open={open1}
                        onClose={handleClose1}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <div className="" style={{ textAlign: "end" }}>
                            <span
                              onClick={handleClose1}
                              role="button"
                              className="ms-auto"
                            >
                              <img src={cross1} height={20} alt="" />
                            </span>
                          </div>
                          <div className="d-flex mb-5 flex-row align-items-center">
                            <img
                              src={res.image}
                              height={80}
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                            <div className="d-flex flex-column ms-3">
                              <span
                                style={{
                                  color: "rgb(255, 255, 255)",
                                  fontFamily: "Inter",
                                  fontSize: "29px",
                                  fontWeight: "700",
                                }}
                              >
                                {res.name}
                              </span>
                              <span style={{ color: "#fff" }}> {res.deg} </span>
                              <a
                                href={res.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                <img
                                  src={teamLinkedin}
                                  width={25}
                                  alt=""
                                  srcSet=""
                                />
                              </a>
                            </div>
                          </div>
                          <p
                            className="typography"
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            {/* {// console.log(idKnowMore)} */}

                            {/* {idKnowMore === res.id 
                          ? 
                         res.moreAbout  : "" } */}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: res.moreAbout,
                              }}
                            />
                          </p>
                        </Box>
                      </Modal>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
      <div className="container-fluid">
        {page === "home" ? (
          <img
            src={flowerImg}
            className="flower-img"
            style={{ left: "-19%", top: "40%", zIndex: "0" }}
            alt=""
            srcSet=""
          />
        ) : (
          ""
        )}
        <hr style={{ color: "#A3A3A3" }} className="my-4" />
      </div>
      <div className="container">
        <div
          className="d-flex justify-content-center advisors--heading--about"
          style={{
            color: "#201f24",
            padding: "2rem -1px",
            fontWeight: "700",
            fontSize: "56px",
            zIndex: "10",
          }}
        >
          <span>Advisors</span>
        </div>
        <div className="row justify-content-center">
          {advisorData.map((res) => {
            return (
              <>
                <div className="col-lg-3 col-md-4 px-2" key={res.id}>
                  <div className="team-card d-flex flex-column align-items-center justify-content-center">
                    <img
                      className="team-card-img"
                      src={res.image}
                      alt=""
                      srcSet=""
                    />
                    <div className="text-center advisor-text">
                      <span
                        className="titlespan"
                        style={{
                          fontSize: "25px",
                          color: "#4a3f42",
                          fontWeight: "700",
                        }}
                      >
                        {res.name}
                      </span>
                      <p
                        className="aboutpara"
                        style={{
                          fontSize: "16px",
                          color: "#6f6b6c",
                          fontWeight: "600",
                        }}
                      >
                        {res.deg}
                      </p>
                    </div>
                    <a
                      href={res.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <img src={teamLinkedin} width={25} alt="" srcSet="" />
                    </a>
                    <hr
                      style={{
                        color: "#A3A3A3",
                        width: "100%",
                        border: "1px solid #A3A3A3",
                      }}
                    />
                    <div
                      className="text-center advisor-para"
                      style={{ padding: "0 19px" }}
                    >
                      <p
                        className="aboutpara"
                        style={{
                          fontSize: "11px",
                          color: "#6f6b6c",
                          fontWeight: "400",
                        }}
                      >
                        {res.about}
                      </p>
                    </div>
                    <span
                      role="button"
                      className="mb-4"
                      onClick={() => {
                        setIdKnowMore(res.id);
                        // // console.log(id)
                        setOpen(true);
                      }}
                      style={{ color: "#6f6b6c", textDecoration: "underline" }}
                    >
                      Know More
                    </span>
                    {idKnowMore === res.id ? (
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <div className="" style={{ textAlign: "end" }}>
                            <span
                              onClick={handleClose}
                              role="button"
                              className="ms-auto"
                            >
                              <img src={cross1} alt="" height={20} />
                            </span>
                          </div>
                          <div className="d-flex mb-5 flex-row align-items-center">
                            <img
                              src={res.image}
                              height={80}
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                            <div className="d-flex flex-column ms-3">
                              <span
                                style={{
                                  color: "rgb(255, 255, 255)",
                                  fontFamily: "Inter",
                                  fontSize: "29px",
                                  fontWeight: "700",
                                }}
                              >
                                {res.name}
                              </span>
                              <span style={{ color: "#fff" }}> {res.deg} </span>
                              <a
                                href={res.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                <img
                                  src={teamLinkedin}
                                  width={25}
                                  alt=""
                                  srcSet=""
                                />
                              </a>
                            </div>
                          </div>
                          <p
                            className="typography"
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            {/* {// console.log(idKnowMore)} */}

                            {/* {idKnowMore === res.id 
                          ? 
                         res.moreAbout  : "" } */}
                            {res.moreAbout}
                          </p>
                        </Box>
                      </Modal>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Team;
